import Immutable from 'seamless-immutable';
import _ from 'lodash';
import moment from 'moment';

import {
  SAVE_POWER_CONTROL_UNITS,
  APPEND_POWER_CONTROL_UNITS,
  UPDATE_POWER_CONTROL_UNIT,
  SELECT_POWER_CONTROL_UNIT,
  SET_POWER_CONTROL_UNIT_OPERATIONAL_MODE,
  SET_POWER_CONTROL_UNITS_PAGINATION_DATA,
  RESET_POWER_CONTROL_UNITS_PAGINATION_DATA,
  SET_POWER_CONTROL_UNITS_FILTER,
  RESET_POWER_CONTROL_UNITS_FILTERS,
  SET_POWER_CONTROL_UNITS_ORDER,
  SAVE_POWER_CONTROL_UNIT_EVENTS,
  APPEND_POWER_CONTROL_UNIT_EVENTS,
  SET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA,
  RESET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA,
  SET_POWER_CONTROL_UNIT_EVENTS_FILTER,
  SAVE_POWER_CONTROL_UNITS_OVERVIEW,
  SAVE_POWER_CONTROL_UNITS_POWER_ON_HOURS,
  SAVE_POWER_CONTROL_UNITS_ENERGY_SUMMARY,
  SAVE_POWER_CONTROL_UNITS_ALERTS,
  SAVE_POWER_CONTROL_UNIT_DEVICES,
} from '../actions/actionTypes/powerControlUnits';

const initialState = Immutable({
  data: {
    content: [],
    filters: {
      state: null,
      gatewayId: null,
      automationEnabled: null,
      areaId: null,
    },
    pagination: {},
    sorting: {
      orderBy: undefined,
      orderDir: undefined,
    },
    lastUpdate: 0,
  },
  selectedPCU: {},
  events: {
    content: [],
    pagination: {},
    filters: {
      fromDate: moment().startOf('month').valueOf(),
      toDate: moment().endOf('month').valueOf(),
      eventType: null,
    },
  },
  overview: {
    totalUnits: 0,
    unitsOn: 0,
    unitsOff: 0,
    estimatedLoadKw: 0,
    lastUpdate: 0,
  },
  powerOnHours: {
    days: [],
    lastUpdate: 0,
  },
  energySummary: {
    avoidedKwhYearToDate: null,
    avoidedCostYearToDate: null,
    currency: null,
    months: [],
    lastUpdate: 0,
  },
  alerts: {
    content: [],
    lastUpdate: 0,
  },
  devices: {
    relays: [],
    presenceSensor: null,
    doorSensors: [],
    triggerLocksOn: [],
    triggerLocksOff: [],
  },
  isOperationalMode: false,
});

export default function powerControlUnitsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_POWER_CONTROL_UNITS:
      return state.setIn(['data', 'content'], action.payload).setIn(['data', 'lastUpdate'], moment().valueOf());

    case APPEND_POWER_CONTROL_UNITS:
      return state.updateIn(['data', 'content'], content => content.concat(action.payload)).setIn(['data', 'lastUpdate'], moment().valueOf());

    case UPDATE_POWER_CONTROL_UNIT: {
      const index = state.data.content.findIndex(pcu => pcu.id === action.payload.id);
      if (index !== -1) {
        return state.setIn(['data', 'content', index], action.payload);
      }
      return state;
    }

    case SELECT_POWER_CONTROL_UNIT:
      return state.set('selectedPCU', action.payload);

    case SET_POWER_CONTROL_UNIT_OPERATIONAL_MODE:
      return state.set('isOperationalMode', action.payload);

    case SET_POWER_CONTROL_UNITS_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], action.payload);

    case RESET_POWER_CONTROL_UNITS_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], {});

    case SET_POWER_CONTROL_UNITS_FILTER:
      return state.setIn(['data', 'filters', action.payload.name], action.payload.value);

    case RESET_POWER_CONTROL_UNITS_FILTERS:
      return state.setIn(['data', 'filters'], initialState.data.filters);

    case SET_POWER_CONTROL_UNITS_ORDER:
      return state
        .setIn(['data', 'sorting', 'orderBy'], action.payload.orderBy)
        .setIn(['data', 'sorting', 'orderDir'], action.payload.orderDir);

    case SAVE_POWER_CONTROL_UNIT_EVENTS:
      return state.setIn(['events', 'content'], action.payload);

    case APPEND_POWER_CONTROL_UNIT_EVENTS:
      return state.updateIn(['events', 'content'], content => content.concat(action.payload));

    case SET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA:
      return state.setIn(['events', 'pagination'], action.payload);

    case RESET_POWER_CONTROL_UNIT_EVENTS_PAGINATION_DATA:
      return state.setIn(['events', 'pagination'], {});

    case SET_POWER_CONTROL_UNIT_EVENTS_FILTER:
      return state.setIn(['events', 'filters', action.payload.name], action.payload.value);

    case SAVE_POWER_CONTROL_UNITS_OVERVIEW:
      return state.set('overview', {
        ...action.payload,
        lastUpdate: moment().valueOf(),
      });

    case SAVE_POWER_CONTROL_UNITS_POWER_ON_HOURS:
      return state.set('powerOnHours', {
        days: action.payload.days || [],
        lastUpdate: moment().valueOf(),
      });

    case SAVE_POWER_CONTROL_UNITS_ENERGY_SUMMARY:
      return state.set('energySummary', {
        ...action.payload,
        months: action.payload.months || [],
        lastUpdate: moment().valueOf(),
      });

    case SAVE_POWER_CONTROL_UNITS_ALERTS:
      return state.set('alerts', {
        content: action.payload || [],
        lastUpdate: moment().valueOf(),
      });

    case SAVE_POWER_CONTROL_UNIT_DEVICES:
      return state.set('devices', action.payload);

    default:
      return state;
  }
}
